import { render, staticRenderFns } from "./HomeLink.vue?vue&type=template&id=f9566cb4&"
import script from "./HomeLink.vue?vue&type=script&lang=ts&"
export * from "./HomeLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports